import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/layout/page-layout'
import { LocalePicker } from '@/components/locale-picker'
import { KioskPinSettings } from '@/components/organisms/profile-settings/kiosk-pin-settings'
import { ProfileSettings } from '@/components/organisms/profile-settings/profile-settings'
import { ThemeToggle } from '@/components/theme-toggle'
import { Field, FieldLabel } from '@/components/ui/field'
import { PermissionsUtils } from '@/utils/permissions.utils'

export const Route = createFileRoute('/_authenticated/settings')({
  component: SettingsPage,
})

function SettingsPage() {
  const { t } = useTranslation()

  return (
    <PageLayout title={t('global.settings')}>
      <ProfileSettings />
      {PermissionsUtils.hasPermission('time-entries:create') && <KioskPinSettings />}
      <div className="card">
        <Field>
          <FieldLabel>{t('settingsPage.languageLabel')}</FieldLabel>
          <div>
            <LocalePicker />
          </div>
        </Field>
        <Field>
          <FieldLabel>{t('settingsPage.appearanceLabel')}</FieldLabel>
          <div>
            <ThemeToggle />
          </div>
        </Field>
      </div>
    </PageLayout>
  )
}
